import axios from 'axios';
import { VUE_APP_API_URL } from '@/utilities/constants.js';

export const state = initialState();

export const actions = {
  getTemplateFields: async ({ commit }) => {
    const res = await axios.get(`${VUE_APP_API_URL}/template-fields`);

    commit('mutateTemplateFields', res.data);
  },

  getTemplateKinds: async ({ commit }) => {
    try {
      const res = await axios.get(`${VUE_APP_API_URL}/kinds`);

      commit('mutateTemplateKinds', res.data);
      return res.status;
    } catch (err) {
      console.error(err);
      return;
    }
  }
};

export const mutations = {
  mutateTemplateFields: (state, payload) => {
    state.templateFields = payload;
  },

  mutateTemplateKinds: (state, payload) => {
    state.templateKinds = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    templateFields: [],
    templateKinds: []
  };
}
